export default __webpack_public_path__ + "static/eshop-nav-2044a1d7a57bd0eedabc70d328d91d8e.svg";